if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
    $(document).on('opened', '.remodal', function (e) {
        if ($(e.target).hasClass('exclude-from-navigator')) {
            return;
        }
        $('.remodal-wrapper')
        .css({
            position: 'absolute',
            marginTop: $(window).scrollTop() + 'px',
            bottom: 'auto'
        });

        // Position backdrop absolute and make it span the entire page
        //
        // Also dirty, but we need to tap into the backdrop after Bootstrap
        // positions it but before transitions finish.
        //
        setTimeout(function () {
            $('.remodal-overlay').css({
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '100%',
                height: Math.max(
                document.body.scrollHeight, document.documentElement.scrollHeight,
                document.body.offsetHeight, document.documentElement.offsetHeight,
                document.body.clientHeight, document.documentElement.clientHeight
            ) + 'px'
            });
        }, 0);
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/modules/remodal/mobile-fix.js